import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';


const userData = {
    username: '',
    password: '',
    passwordRepeat: '',
};

class CreateUserModal extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            userData: userData
        };

        this.cancel = this.cancel.bind(this);
        this.setProperty = this.setProperty.bind(this);
        this.validate = this.validate.bind(this);
        this.passwordsMatch = this.passwordsMatch.bind(this);
        this.submit = this.submit.bind(this);
    }

    cancel() {
        this.setState({userData: userData});
        this.props.onCancel();
    }

    setProperty(propertyName, propertyValue) {
        let userData = this.state.userData;
        userData[propertyName] = propertyValue;
        this.setState({userData: userData});
    }

    submit() {
        this.props.onSubmit(this.state.userData);
    }

    validate() {
        return this.state.userData.username !== '' && this.passwordsMatch();
    }

    passwordsMatch() {
        return this.state.userData.password !== '' && this.state.userData.password === this.state.userData.passwordRepeat;
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.setState({userData: userData});
        }
    }

    render() {

        const valid = this.validate();
        const passWordsMatch = this.passwordsMatch();
        return (
            <Modal isOpen={this.props.visible} centered={true} className={this.props.className}>
                <ModalHeader>Neuer Benutzer</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-lg-10">
                            <form>
                                <div className="form-group">
                                    <label htmlFor="csModalUsername">Benutzername</label>
                                    <input type="text" className="form-control" id="csModalUsername"
                                           onChange={(event) => this.setProperty('username', event.target.value)}
                                           placeholder="Benutzername" required={true}/>
                                </div>
                                <div className="form-group">
                                    <label className="control-label" htmlFor="csModalPassword">Passwort</label>
                                    <input type="password" className="form-control" id="csModalPassword"
                                           onChange={(event) => this.setProperty('password', event.target.value)}
                                           placeholder="Passwort..." required={true}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="csModalPasswordRepeat">Passwort wiederholen</label>
                                    <input type="password" className="form-control" id="csModalPasswordRepeat"
                                           onChange={(event) => this.setProperty('passwordRepeat', event.target.value)}
                                           placeholder="Passwort wiederholen..." required={true}/>
                                    <div className="invalid-feedback">
                                        Please provide a valid state.
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button disabled={!valid} color="primary" onClick={this.submit}>Benutzer anlegen</Button>{' '}
                    <Button color="secondary" onClick={this.cancel}>Abbrechen</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default CreateUserModal;



// WEBPACK FOOTER //
// ./src/admin/user/CreateUserModal.js